module.exports = __webpack_public_path__ + "img/9bbc81f.jpg";